// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-module__container--tgk5r{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.title-module__container--tgk5r:hover{color:#36b}.title-module__container--tgk5r:hover .title-module__icon--3bdki path{fill:#36b}.title-module__icon--3bdki{vertical-align:middle}.title-module__title--1TikJ{cursor:pointer;color:#303030;font-weight:600;font-size:16px;line-height:24px;letter-spacing:0px}.title-module__subtitle--3bvOt{margin-top:5px;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0;color:#616161}.title-module__iconWrapper--3mcs0{position:relative;padding-right:16px}\n", ""]);
// Exports
exports.locals = {
	"container": "title-module__container--tgk5r",
	"icon": "title-module__icon--3bdki",
	"title": "title-module__title--1TikJ",
	"subtitle": "title-module__subtitle--3bvOt",
	"iconWrapper": "title-module__iconWrapper--3mcs0"
};
module.exports = exports;
